import * as React from "react"
import {Box, CircularProgress, Typography} from "@mui/material";
import {ButtonIconSeeker, TextFieldSeeker} from "@ui-seeker/core";

import {isLoadMoreItems, reverseMatcherItems} from "../../@signals"


export default function ReverseMatcherTargetActionsPagination({ number, setNumber, isLoadingMapping }) {
	const totalItems = reverseMatcherItems.value.length

	return <Box sx={{ display: 'flex', justifyContent: 'space-evelyn', gap: 2 }}>
		<ButtonIconSeeker
			disabled={number === 0 || isLoadingMapping}
			icon="angle-left"
			onClick={() => setNumber(number - 1)}
		/>

		<TextFieldSeeker
			fullWidth={false}
			sx={{ width: 50 }}
			value={(number + 1).toString()}
			onChange={e => {
				const newValue = e.target.value
				if (newValue) {
					const valueInt = parseInt(e.target.value)
					if (valueInt <= totalItems) setNumber(valueInt - 1)
				}
			}}
		/>

		<Typography sx={{ alignItems: 'center', verticalAlign: 'center', p: 1 }}>
			/ { !!isLoadMoreItems.value ? <CircularProgress size={21}/> : totalItems }
		</Typography>

		<ButtonIconSeeker
			disabled={(number + 1) > totalItems || isLoadingMapping}
			icon="angle-right"
			onClick={() => setNumber(number + 1)}
		/>
	</Box>
}